import api from 'src/constants/api'

import useAccount from 'src/hooks/utils/useAccount'
import useMutation from 'src/hooks/utils/useMutation'

const useDeleteWebhookMutation = () => {
  const account = useAccount()

  return useMutation(
    async (webhookId: string) => {
      const response = await api.delete(`/webhooks/account/${account.id}/webhooks/${webhookId}`)
      return response.data
    },
    {
      mutationKey: ['deleteWebhook'],
      successMessage: 'Webhook deleted successfully',
      errorMessage: 'Failed to delete webhook',
      queryKeysToInvalidate: [['getWebhooks', account.id]]
    }
  )
}

export default useDeleteWebhookMutation
